import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonLogoComponent } from './common-logo.component';
import { PieChartComponent } from '../pie-chart/pie-chart.component';
import { BarChartComponent } from '../bar-chart/bar-chart.component';
import { AuthGuard } from 'src/app/shared/helpers/auth_guards/auth.guard';
import { TpRoleGuard } from 'src/app/shared/helpers/auth_guards/tp-role.guard';
import { VoyagerequestListComponent } from '../voyagerequest-form/voyagerequest-list/voyagerequest-list.component';

const routes: Routes = [
  {
    path: '',
    component: CommonLogoComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },

      {
        path: 'home',
        loadChildren: () =>
          import('../landing-page/landing-page.module').then(
            (m) => m.LandingPageModule,
          ),
      },
      {
        path: 'vp-fleetView',
        loadChildren: () =>
          import('../fleet-view/fleet-view.module').then(
            (m) => m.FleetViewModule,
          ),
      },
      {
        path: 'vp-detailedView',
        loadChildren: () =>
          import('../fleet-view/detailed-view/detailed-view.module').then(
            (m) => m.DetailedViewModule,
          ),
      },
      {
        path: 'vp-CharterpartyTable',
        loadChildren: () =>
          import('../table/table.module').then((m) => m.TableModule),
      },
      {
        path: 'vp-tcpGraphs',
        loadChildren: () =>
          import('../databasetab/tcp-graph/tcp-graph.module').then((m) => m.TcpGraphModule),
      },
      {
        path: 'vp-shipView',
        loadChildren: () =>
          import('../ship-view-table/ship-view-table.module').then(
            (m) => m.ShipViewTableModule,
          ),
      },
      {
        path: 'vp-dialyReport',
        loadChildren: () =>
          import('../daily-report/daily-report.module').then(
            (m) => m.DailyReportModule,
          ),
      },
      {
        path: 'vp-periodicReport',
        loadChildren: () =>
          import('../periodic-report/periodic-form/periodic-form.module').then(
            (m) => m.PeriodicFormModule,
          ),
      },
      {
        path: 'vp-periodicReportTable',
        loadChildren: () =>
          import('../periodic-report/periodic-report.module').then(
            (m) => m.PeriodicReportModule,
          ),
      },

      {
        path: 'vp-pieChart',
        component: PieChartComponent,
      },
      {
        path: 'vp-barChart',
        component: BarChartComponent,
      },
      {
        path: 'vp-requestForm',
        loadChildren: () =>
          import('../requestform-home/requestform-home.module').then(
            (m) => m.RequestformHomeModule,
          ),
      },
      {
        path: 'vp-updateTable',
        loadChildren: () =>
          import('../update-table/update-table.module').then(
            (m) => m.UpdateTableModule,
          ),
      },
      {
        path: 'vp-retriveForm',
        loadChildren: () =>
          import('../retrive-form/retrive-form.module').then(
            (m) => m.RetriveFormModule,
          ),
      },
      {
        path: 'vp-database',
        loadChildren: () =>
          import('../databasetab/databasetab.module').then(
            (m) => m.DatabasetabModule,
          ),
      },
      {
        path: 'vp-fleet-performance',
        loadChildren: () =>
          import('../databasetab/fleet-performance/fleet-performance.module').then(
            (m) => m.FleetPerformanceModule,
          ),
      },
      {
        path: 'vp-performanceGraph',
        loadChildren: () =>
          import('../performance-graph/performance-graph.module').then(
            (m) => m.PerformanceGraphModule,
          ),
      },
      {
        path: 'vp-onboardingForm',
        loadChildren: () =>
          import('../onboarding-form/onboarding-form.module').then(
            (m) => m.OnboardingFormModule,
          ),
      },
      {
        path: 'vp-tp-dashboard',
        canActivate: [TpRoleGuard],
        loadChildren: () =>
          import('../tp-graphs/tp-dashboard/tp-dashboard.module').then(
            (m) => m.TpDashboardModule
          ),
      },
      {
        path: 'vp-graphs',
        loadChildren: () =>
          import('../tp-graphs/tp-graphs.module').then(
            (m) => m.TpGraphsModule
          ),
      },
      {
        path: 'vp-voyage-series',
        canActivate: [TpRoleGuard],
        loadChildren: () =>
          import('../tp-graphs/voyage-tp-graphs/voyage-tp-graphs.module').then(
            (m) => m.VoyageTpGraphsModule
          ),
      },
      {
        path: 'vp-dt-comparison',
        canActivate: [TpRoleGuard],
        loadChildren: () =>
          import('../tp-graphs/dt-comparison/dt-comparison.module').then(
            (m) => m.DtComparisonModule
          ),
      },

      // {
      //   path: 'heatingPlan',
      //   component: HeatingPlanComponent,
      // },

      // {
      //   path: 'databaseForm',
      //   component: DatabaseTableComponent,
      // },
      // {
      //   path: 'vp-databaseInport',
      //   component: ImportDatabaseComponent,
      // },

      // {
      //   path: 'test',
      //   component: TestingPageComponent,
      // },
      // {
      //   path: 'testMap',
      //   component: TestMapComponent,
      // },
      // {
      //   path: 'uploadFile',
      //   component: FileUploadComponent,
      // },
      // {
      //   path: 'speedConsGraph',
      //   component: SpeedConsumptionGraphComponent,
      // },
      // Port Consumption URLs
      {
        path: 'pc-home',
        loadChildren: () =>
          import('../PC_modules/port-dashboard/port-dashboard.module').then(
            (m) => m.PortDashboardModule,
          ),
      },
      {
        path: 'pc-fleetView',
        loadChildren: () =>
          import('../PC_modules/port-home/port-home.module').then(
            (m) => m.PortHomeModule,
          ),
      },
      {
        path: 'pc-dashboard/:tab',
        loadChildren: () =>
          import('../PC_modules/port-common-table/port-common-table.module').then(
            (m) => m.PortCommonTableModule,
          ),
      },
      {
        path: 'ms-requestForm',
        loadChildren: () =>
          import('../PC_modules/port-request-form/port-request-form.module').then(
            (m) => m.PortRequestFormModule,
          ),
      },
      {
        path: 'pc-vesselView',
        loadChildren: () =>
          import('../PC_modules/vessel-view/vessel-view.module').then(
            (m) => m.VesselViewModule,
          ),
      },

      {
        path: 'priodic-form',
        loadChildren: () =>
          import('../PC_modules/priodic-form/priodic-form.module')
            .then(m => m.PriodicFormModule)
      },
      {
        path: 'cp-report',
        loadChildren: () =>
          import('../PC_modules/cpreport-form/cpreport-form.module')
            .then(m => m.CpreportFormModule)
      },

      {
        path: 'pc-data-qualitycheck',
        loadChildren: () =>
          import('../PC_modules/dataqueality-checkform/dataqueality-checkform.module')
            .then(m => m.DataquealityCheckformModule)
      },
      {
        path: 'pc-myrequest',
        loadChildren: () =>
          import('../PC_modules/port-my-request/port-my-request.module').then(
            (m) => m.PortMyRequestModule,
          ),
      },
      {
        path: 'pc-settings',
        loadChildren: () =>
          import('../PC_modules/setting-screen/pages/upload-popup/uploading-files/uploading-files.module').then(
            (m) => m.UploadingFilesModule,
          ),
      },
      {
        path: 'pc-database',
        loadChildren: () =>
          import('../PC_modules/port-database/port-database.module').then(
            (m) => m.PortDatabaseModule,
          ),
      },
      {
        path: 'pc-OnboardingVessels',
        loadChildren: () =>
          import('../PC_modules/onboarding-vessels/onboarding-vessels.module').then(
            (m) => m.OnboardingVesselsModule,
          ),
      },
      {
        path: 'pc-Q88',
        loadChildren: () =>
          import('../PC_modules/q88/q88.module').then((m) => m.Q88Module),
      },
      {
        path: 'pc-newForm',
        loadChildren: () =>
          import('../PC_modules/master-newform/master-newform.module').then(
            (m) => m.MasterNewformModule,
          ),
      },
      {
        path: 'ms-vesselSummary',
        loadChildren: () =>
          import('../PC_modules/master-newform/previous-vessel-summary-routing/prvious-vessel-summary.routing.module').then(
            (m) => m.PreviousVesselSummaryRoutingModule
          ),
      },

      {
        path: 'update-vessel-data',
        loadChildren: () =>
          import('../updatevessel-data/updatevessel-data-routing.module')
            .then(m => m.UpdatevesselDataRoutingModule)
      },
      {
        path: 'vp-simulation-dashboard',
        loadChildren: () =>
          import('../simulation-dashboard/simulation-dashboard.module')
            .then(m => m.SimulationDashboardModule)
      }
      ,
      {
        path: 'api-usage',
        loadChildren: () =>
          import('../api-usage/api-usage.module')
            .then(m => m.ApiUsageModule)
      }
      ,
      {
        path: 'client-ownership',
        loadChildren: () =>
          import('../client-ownership/client-ownership.module')
            .then(m => m.ClientOwnershipModule)
      }
      ,
      {
        path: 'admin/report-desk',
        canActivate: [TpRoleGuard],
        loadChildren: () =>
          import('../admin-report-desk/admin-report-desk.module')
            .then(m => m.AdminReportDeskModule)
      }
      ,
      {
        path: 'voyage-performance',
        loadChildren: () => import('../voyagerequest-form/voyagerequest-form-routing.module')
          .then(m => m.VoyagerequestFormRoutingModule)
      },
      {
        path: 'routing-request',
        loadChildren: () => import('../voyagerequest-form/voyagerequest-form-routing.module')
          .then(m => m.VoyagerequestFormRoutingModule)
      },
      {
        path: 'routing-request-list',
        component: VoyagerequestListComponent
      },
      {
        path: 'rm-createdRoutes',
        loadChildren: () => import('../created-routes/created-routes.module')
          .then(m => m.CreatedRoutesModule)
      },
      {
        path: 'rm-routingMap',
        loadChildren: () => import('../routing-map/routing-map.module')
          .then(m => m.RoutingMapModule)
      },
      {
        path: 'pc-charter-performance',
        loadChildren: () =>
          import('../PC_modules/charter-performance-pc/charter-performance-pc-routing.module')
            .then(m => m.CharterPerformancePCRoutingModule)
      },
      {
        path: 'pc-inside-charter-view',
        loadChildren: () =>
          import('../PC_modules/insidecharter-view/insidecharter-view-routing.module')
            .then(m => m.InsidecharterViewRoutingModule)
      },
      {
        path: 'pc-inside-tech-view',
        loadChildren: () =>
          import('../PC_modules/insidetech-view/insidetech-view-routing.module')
            .then(m => m.InsidetechViewRoutingModule)
      },
      {
        path: 'pc-technical-performance',
        loadChildren: () =>
          import('../PC_modules/tenchnical-performance-pc/technical-performance-pc-routing.module')
            .then(m => m.TechnicalPerformancePCRoutingModule)
      },
      {
        path: 'pc-graphical-view',
        loadChildren: () =>
          import('../PC_modules/graphical-view-pc/graphical-view-pc-routing.module')
            .then(m => m.GraphicalViewPCRoutingModule)
      },
      {
        path: 'pc-optimization',
        loadChildren: () =>
          import('../PC_modules/pc-optimizationview/pc-optimizationview-routing.module')
            .then(m => m.PcOptimizationviewRoutingModule)
      },
      {
        path: 'pc-consumption-exceptions',
        loadChildren: () =>
          import('../PC_modules/consumption-exceptions/consumption-exceptions.module')
            .then((m) => m.ConsumptionExceptionsModule),
      },
      // Cargo Heating URLs
      {
        path: 'ch-home',
        loadChildren: () =>
          import('../Cargo_Heating_modules/c-home/c-home.module').then(
            (m) => m.CHomeModule,
          ),
      },
      {
        path: 'ch-analyticsDashboard',
        loadChildren: () =>
          import('../Cargo_Heating_modules/analytics-dashboard/analytics-dashboard.module').then(
            (m) => m.AnalyticsDashboardModule,
          ),
      },
      {
        path: 'ch-graph',
        loadChildren: () =>
          import('../Cargo_Heating_modules/graphs/graphs.module').then(
            (m) => m.GraphsModule,
          ),
      },
      {
        path: 'detailed-view',
        loadChildren: () =>
          import('../Cargo_Heating_modules/detailed-view/detailed-view.module')
            .then(m => m.DetailedViewModule)
      },
      {
        path: 'ch-requestForm',
        loadChildren: () =>
          import('../Cargo_Heating_modules/c-request-form/c-request-form.module').then(
            (m) => m.CRequestFormModule,
          ),
      },
      {
        path: 'ch-allRequests',
        loadChildren: () =>
          import('../Cargo_Heating_modules/all-requests/all-reports/all-reports.module').then(
            (m) => m.AllReportsModule,
          ),
      },
      {
        path: 'ch-reportTable',
        loadChildren: () =>
          import('../Cargo_Heating_modules/graphs/pages/reports-table/reports-table.module').then(
            (m) => m.ReportsTableModule,
          ),
      },
      {
        path: 'ch-heatPlanGraph',
        loadChildren: () =>
          import('../Cargo_Heating_modules/heat-plan-graph/heat-plan-graph.module').then(
            (m) => m.HeatPlanGraphModule,
          ),
      },
      {
        path: 'ch-finalReport',
        loadChildren: () =>
          import('../Cargo_Heating_modules/graphs/pages/final-report/final-report.module').then(
            (m) => m.FinalReportModule,
          ),
      },
      {
        path: 'ch-pivottable',
        loadChildren: () =>
          import('../Cargo_Heating_modules/pivot-table/pivot-table.module').then(
            (m) => m.PivotTableModule,
          ),
      },
      {
        path: 'ch-benchmark',
        loadChildren: () =>
          import('../Cargo_Heating_modules/benchmarking/benchmarking.module').then(
            (m) => m.BenchmarkingModule,
          ),
      },
      {
        path: 'ch-databaseForm',
        loadChildren: () =>
          import('../Cargo_Heating_modules/database-form/database-form.module').then(
            (m) => m.DatabaseFormModule,
          ),
      },
      {
        path: 'ch-forecastTemp',
        loadChildren: () =>
          import('../Cargo_Heating_modules/forecast-temperatures-drop/forecast-temperatures-drop.module').then(
            (m) => m.ForecastTemperaturesDropModule,
          ),
      },
      {
        path: 'ch-totalShip',
        loadChildren: () =>
          import('../Cargo_Heating_modules/total-ship-table/total-ship-table.module').then(
            (m) => m.TotalShipTableModule,
          ),
      },
      {
        path: 'ch-finalForm',
        loadChildren: () =>
          import('../Cargo_Heating_modules/database-form/final-form/final-form.module').then(
            (m) => m.FinalFormModule,
          ),
      },
      {
        path: 'ch-optimization',
        loadChildren: () =>
          import('../Cargo_Heating_modules/cargo-heating-optimization/cargo-heating-optimization.module').then(
            (m) => m.CargoHeatingOptimizationModule,
          ),
      },

      {
        path: 'voyage-metrics',
        loadChildren: () =>
          import('../Cargo_Heating_modules/voyage-materics/voyage-materics.module')
            .then(m => m.VoyageMatericsModule)
      },
      // Emissions URLs
      {
        path: 'E-dashboard2',
        loadChildren: () =>
          import('../Emission_modules/emision-analytics/emision-analytics.module').then(
            (m) => m.EmisionAnalyticsModule,
          ),
      },
      {
        path: 'E-dashboard',
        loadChildren: () =>
          import('../Emission_modules/emission-home/emission-home.module').then(
            (m) => m.EmissionHomeModule,
          ),
      },
      {
        path: 'E-cii',
        loadChildren: () =>
          import('../Emission_modules/cii/cii.module').then((m) => m.CiiModule),
      },
      {
        path: 'E-euEts',
        loadChildren: () =>
          import('../Emission_modules/eu-ets/table-view-euets/table-view-euets.module').then(
            (m) => m.TableViewEUETSModule,
          ),
      },
      {
        path: 'E-ciitable/:imo',
        loadChildren: () =>
          import('../Emission_modules/cii/table-view-cii/table-view-cii.module').then(
            (m) => m.TableViewCIIModule,
          ),
      },
      {
        path: 'E-overview-table/:imo',
        loadChildren: () =>
          import('../Emission_modules/emission-overview/table-view-emission-overview/table-view-emission-overview.module').then(
            (m) => m.TableViewEmissionOverviewModule,
          ),
      },
      {
        path: 'E-tableview/:imo',
        loadChildren: () =>
          import('../Emission_modules/eu-ets/eu-ets.module').then(
            (m) => m.EuEtsModule,
          ),
      },
      {
        path: 'E-fuelEU',
        loadChildren: () =>
          import('../Emission_modules/fuel-eu/fuel-eu.module').then(
            (m) => m.FuelEuModule,
          ),
      },
      {
        path: 'E-uk-mrv',
        loadChildren: () =>
          import('../Emission_modules/UK/mrv/mrv.module').then(
            (m) => m.MRVModule,
          ),
      },
      {
        path: 'E-Overview',
        loadChildren: () =>
          import('../Emission_modules/emission-overview/emission-overview.module').then(
            (m) => m.EmissionOverviewModule,
          ),
      },
      {
        path: 'E-ImoDcs',
        loadChildren: () =>
          import('../Emission_modules/imo-dcs/imo-dcs.module').then(
            (m) => m.ImoDCSModule,
          ),
      },
      {
        path: 'E-Uk-ShipView/:imo',
        loadChildren: () =>
          import('../Emission_modules/UK/ukmrv-ship-view/ukmrv-ship-view.module').then(
            (m) => m.UkmrvShipViewModule,
          ),
      },
      {
        path: 'E-FuelUl-ShipView/:imo',
        loadChildren: () =>
          import('../Emission_modules/fuel-eu/fuel-ul-ship-view/fuel-ul-ship-view.module').then(
            (m) => m.FuelUlShipViewModule,
          ),
      },
      {
        path: 'E-Bdn-InsideView',
        loadChildren: () =>
          import('../Emission_modules/cii/inside-bdn-view/inside-bdn-view.module').then(
            (m) => m.InsideBdnViewModule,
          ),
      },
      // Tank Cleaning URLs
      {
        path: 'tc-form',
        loadChildren: () =>
          import('../Tank_Cleaning_modules/tc-form/tc-form.module').then(
            (m) => m.TcFormModule,
          ),
      },
      // Port Weather URLs
      {
        path: 'pw-home',
        loadChildren: () =>
          import('../Port_weather_modules/pw-home/pw-home.module').then(
            (m) => m.PwHomeModule,
          ),
      },
      {
        path: 'pw-myrequest',
        loadChildren: () =>
          import('../Port_weather_modules/pw-my-requests/pw-my-requests.module').then(
            (m) => m.PwMyRequestsModule,
          ),
      },
      {
        path: 'vp-underDevelopment',
        loadChildren: () =>
          import('../testing-page/pages/test-map/test-map.module').then(
            (m) => m.TestMapModule,
          ),
      },
      {
        path: 'vp-underDevelopment',
        loadChildren: () =>
          import(
            '../testing-page/pages/test-map/test-map.module'
          ).then((m) => m.TestMapModule),
      },
      {
        path: 'ais-vessels',
        loadChildren: () =>
          import(
            '../ais-vessels/ais-vessels.module'
          ).then((m) => m.AisVesselsModule),
      },
      {
        path: 'ai-insights',
        loadChildren: () =>
          import('../ai-analysis/ai-analysis.module').then(
            (m) => m.AiAnalysisModule
          ),
      },
      {
        path: 'vp-test-page',
        loadChildren: () =>
          import('../testing-page/testing-page.module').then(
            (m) => m.TestingPageModule
          ),
      },
      {
        path: 'd-home',
        loadChildren: () =>
          import('../demurrage_modules/demurrage-home/demurrage-home.module').then(
            (m) => m.DemurrageHomeModule
          ),
      },
      {
        path: 'd-form',
        loadChildren: () =>
          import('../demurrage_modules/demurrage-form/demurrage-form.module').then(
            (m) => m.DemurrageFormModule
          ),
      },
      {
        path: 'dis-dashboard',
        loadChildren: () =>
          import('../Disbursment_modules/dis-dashboard/dis-dashboard.module').then(
            (m) => m.DisDashboardModule
          ),
      },
      {
        path: 'dis-repository',
        loadChildren: () =>
          import('../Disbursment_modules/dis-repository/dis-repository.module').then(
            (m) => m.DisRepositoryModule
          ),
      },
      {
        path: 'dis-mastertabs',
        loadChildren: () =>
          import('../Disbursment_modules/master-tabs/master-tabs.module').then(
            (m) => m.MasterTabsModule
          ),
      },
      {
        path: 'dis-pda',
        loadChildren: () =>
          import('../Disbursment_modules/pda/pda.module').then(
            (m) => m.PdaModule
          ),
      },
      {
        path: 'dis-pda-edit',
        loadChildren: () =>
          import('../Disbursment_modules/pda-edit/pda-edit.module').then(
            (m) => m.PdaEditModule
          ),
      },
      {
        path: 'dis-fda-edit',
        loadChildren: () =>
          import('../Disbursment_modules/fda-edit/fda-edit.module').then(
            (m) => m.FdaEditModule
          ),
      },
        {
        path: 'dis-towage-edit',
        loadChildren: () =>
          import('../Disbursment_modules/towage-edit/towage-edit.module').then(
            (m) => m.TowageEditModule
          ),
      },
      {
        path: 'dis-fda',
        loadChildren: () =>
          import('../Disbursment_modules/fda/fda.module').then(
            (m) => m.FdaModule
          ),
      },
      {
        path: 'dis-disbursment',
        loadChildren: () =>
          import('../Disbursment_modules/disbursment/disbursment.module').then(
            (m) => m.DisbursmentModule
          ),
      },
      {
        path: 'dis-meraki-ai',
        loadChildren: () =>
          import('../Disbursment_modules/meraki-ai/meraki-ai.module').then(
            (m) => m.MerakiAiModule
          ),
      },
      {
        path: 'dis-request-form',
        loadChildren: () =>
          import('../Disbursment_modules/dis-request-form/dis-request-form.module').then(
            (m) => m.DisRequestFormModule
          ),
      },
      {
        path: 'dis-my-requests',
        loadChildren: () =>
          import('../Disbursment_modules/dis-request-form/my-requests/my-requests.module').then(
            (m) => m.MyRequestsModule
          ),
      },

      {
        path: 'reports-dashboard',
        loadChildren: () =>
          import('../report-dashboard/report-dashboard.module').then(
            (m) => m.ReportDashboardModule
          ),
      },
       
    ],
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommonLogoRoutingModule { }
